import { SetStateAction } from "react";

import { atom, WritableAtom } from "jotai";

export function onSetAtom<Value, Result>(
    baseAtom: WritableAtom<Value, SetStateAction<Value>[], Result>,
    callback: (newValue: Value) => void
) {
    return atom(
        (get) => get(baseAtom),
        (get, set, update: SetStateAction<Value>) => {
            const old = get(baseAtom);
            set(baseAtom, update);
            if (old !== update && typeof update !== "function") {
                callback(update);
            }
        }
    );
}
